<template>
  <div v-if="loaded" class="default-video-block" :class="{ 'default-video-block--videoresume': isVideoresume }">
    <div class="video_wrapper">
      <videoagreement
        v-if="!isVideointerviewStarted"
        :is-agreement-already-accepted="isAgreementAlreadyAccepted"
        :interview="interview"
        @input="isVideointerviewStarted = true"
      />

      <component
        :is="process"
        v-else
        :interview="interview"
        :is-videoresume="isVideoresume"
        :video-response="videoResponse"
      />
    </div>

    <vfooter
      class="video-footer"
      type="landing"
      :background="!isVideoresume ? '#e5e5e5' : '#fafafa'"
      :is-videoresume="isVideoresume"
      :company_language="company_language"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import basic from './default.vue';
import videoagreement from '@/routes_new/outer/interview/landing/video/components/agreement.vue';
import vfooter from '@/routes_new/outer/components/vfooter.vue';

export default {
  name: 'ProcessVideo',

  components: {
    default: basic,
    videoagreement,
    vfooter
  },

  props: {
    token: {
      type: [String, Number],
      default: null
    },

    process: {
      type: String,
      default: 'default'
    },

    fetch: {
      type: Function,
      default: () => {}
    },

    fromRegistration: {
      type: Boolean,
      default: false
    },

    error: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isVideointerviewStarted: false,
      isAgreementAlreadyAccepted: false
    };
  },

  computed: {
    ...mapGetters('record_interview', {
      interview: 'item',
      isVideoresume: 'isVideoresume',
      videoResponse: 'response',
      loaded: 'loaded'
    }),

    ...mapGetters('interview', ['company_language']),

    company_name() {
      return this.interview.company ? this.interview.company.name : false;
    }
  },

  created() {
    this.isAgreementAlreadyAccepted = Boolean(localStorage.getItem('agree_' + this.token));

    this.$store.dispatch('record_interview/load', this.token).then(r => {
      if (r.data.data[0].vacancy.is_disable_record_videointerview || !r.data.data[0].vacancy.is_active) {
        this.$router.push({ name: 'interview', params: { token: this.token } });
        return false;
      }

      if (r.data.data[0].stage.id !== 'videointerview' && !this.isVideoresume) {
        this.$router.push({ name: 'interview', params: { token: this.token } });
      }

      let title = this.$tr('pageTitles.prefix');
      title = `${this.interview.vacancy.name}. ${this.company_name} - ${title}`;
      document.title = title;

      this.load_landing(r.data.data[0].vacancy.public_token);
    });
  },

  methods: {
    load_landing(token) {
      this.$store.dispatch('landing/load', token);
    }
  }
};
</script>

<style lang="scss" scoped>
.video_wrapper {
  min-height: calc(100% - 3.75rem - 1px);
  flex: 1;
  flex-direction: column;
  display: flex;
  justify-content: center;
  background: #e5e5e5;

  @media screen and (max-width: 1024px) {
    background: #fff;
  }

  @media screen and (max-width: 480px) {
    min-height: calc(100% - 2.5rem - 1px);
  }
}

.default-video-block {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.video-footer {
  @media only screen and (max-width: 1024px) {
    position: sticky;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}

.default-video-block--videoresume {
  .video_wrapper {
    background: #fafafa;
  }
}
</style>
